import { isEventOrganizer } from '../helpers';
import EventCard from '../ui/EventCard';
import CreateEventButton from '../ui/CreateEventButton';

function EventsList({ events, venues, venueEquipment, currentUser, cityFilter, setCityFilter, dateFilter, setDateFilter, mineFilter, setMineFilter, onSelectEvent, onCreateEvent, onEditEvent, onDeleteEvent, defaultVenueBg }) {
  const isVenue=currentUser.accountType==="venue";

  const eventCities=[...new Set(events.map(ev=>ev.city||"").filter(Boolean))].sort();

  const today=new Date(); today.setHours(0,0,0,0);

  const filtered=events.filter(ev=>{
    if(ev.visibility==="private"){
      const isOrganizer=isEventOrganizer(ev,currentUser.id);
      const isParticipant=(ev.event_participants||[]).some(p=>p.musician_id===currentUser.id);
      if(!currentUser.is_admin&&!isOrganizer&&!isParticipant)return false;
    }
    if(mineFilter==="mine"){
      const isOrganizer=isEventOrganizer(ev,currentUser.id);
      const isParticipant=(ev.event_participants||[]).some(p=>p.musician_id===currentUser.id);
      if(!isOrganizer&&!isParticipant)return false;
    }
    if(cityFilter!=="tutti"){
      if(!(ev.city||"").toLowerCase().includes(cityFilter.toLowerCase()))return false;
    }
    const evDate=new Date(ev.date); evDate.setHours(0,0,0,0);
    const diffDays=Math.round((evDate-today)/(1000*60*60*24));
    if(dateFilter==="tutti"&&diffDays<0)return false;
    if(dateFilter==="oggi"&&diffDays!==0)return false;
    if(dateFilter==="10"&&(diffDays<0||diffDays>10))return false;
    if(dateFilter==="30"&&(diffDays<0||diffDays>30))return false;
    if(dateFilter==="passate"&&diffDays>=0)return false;
    return true;
  });

  return (
    <div className="fade-up">
      <div style={{marginBottom:24,textAlign:"center"}}>
        <div style={{fontSize:26,fontWeight:800,color:"var(--text)",lineHeight:1.1}}>Scopri Jam vicine a te</div>
        <div style={{fontSize:16,color:"var(--muted)",marginTop:6}}>Oppure crea tu un evento</div>
      </div>

      {/* Filtro Tue / Tutte */}
      <div style={{display:"flex",gap:6,marginBottom:12}}>
        {[["tutte","Tutte"],["mine","Le tue"]].map(([val,label])=>(
          <button key={val} onClick={()=>setMineFilter(val)}
            style={{padding:"5px 16px",borderRadius:999,border:"none",cursor:"pointer",fontSize:16,fontWeight:600,transition:"all .15s",
              background:(mineFilter||"tutte")===val?"#ED4D1D":"rgba(237,77,29,0.06)",
              color:(mineFilter||"tutte")===val?"#fff":"var(--muted)"}}>
            {label}
          </button>
        ))}
      </div>

      {/* Filtri città e data */}
      <div style={{display:"flex",gap:8,marginBottom:14,flexWrap:"wrap",alignItems:"center"}}>
        <div style={{position:"relative",display:"flex",alignItems:"center"}}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--muted)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{position:"absolute",left:10,pointerEvents:"none"}}>
            <circle cx="12" cy="12" r="3"/><path d="M12 2a7 7 0 0 1 7 7c0 5-7 13-7 13S5 14 5 9a7 7 0 0 1 7-7z"/>
          </svg>
          <select className="form-select" style={{paddingLeft:28,paddingRight:12,paddingTop:6,paddingBottom:6,fontSize:16,width:"auto"}}
            value={cityFilter} onChange={e=>setCityFilter(e.target.value)}>
            <option value="tutti">Tutte le città</option>
            {eventCities.map(c=><option key={c} value={c}>{c}</option>)}
          </select>
        </div>
        <div style={{position:"relative",display:"flex",alignItems:"center"}}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--muted)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{position:"absolute",left:10,pointerEvents:"none"}}>
            <rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
          </svg>
          <select className="form-select" style={{paddingLeft:28,paddingRight:12,paddingTop:6,paddingBottom:6,fontSize:16,width:"auto"}}
            value={dateFilter} onChange={e=>setDateFilter(e.target.value)}>
            <option value="tutti">Prossime</option>
            <option value="oggi">Oggi</option>
            <option value="10">Entro 10 giorni</option>
            <option value="30">Entro 30 giorni</option>
            <option value="passate">Passate</option>
          </select>
        </div>
        <span style={{fontSize:16,color:"var(--muted)",marginLeft:"auto"}}>{filtered.length} serate</span>
      </div>

      {filtered.length===0&&<div className="empty-state">
        <div style={{marginBottom:12}}>Nessuna serata con questi filtri.</div>
        {(mineFilter!=="tutte"||cityFilter!=="tutti"||dateFilter!=="tutti")&&
          <button className="btn btn-secondary btn-sm" onClick={()=>{setMineFilter("tutte");setCityFilter("tutti");setDateFilter("tutti");}}>Rimuovi filtri</button>
        }
      </div>}

      {filtered.map(ev=>(
        <EventCard key={ev.id} ev={ev} venues={venues} currentUser={currentUser} onSelect={onSelectEvent} defaultVenueBg={defaultVenueBg}/>
      ))}

      {/* Bottone crea serata — mostra la richiesta di abilitazione a chi non ce l'ha */}
      {(currentUser.accountType==="musician"||isVenue)&&(
        <CreateEventButton currentUser={currentUser} venues={venues} venueEquipment={venueEquipment}
          onCreateEvent={onCreateEvent} style={{marginTop:20}}/>
      )}
    </div>
  );
}

export default EventsList;
